import React from 'react';
import { htmlDecode } from '../helpers/functions';
import { framer, AnimatePresence, motion } from 'framer-motion';
import cx from 'classnames';

import { ReactComponent as Chevron } from '../assets/chevron-right.svg';

export function IframeAccordion({ accordions }) {
  const accordionBlocks = JSON.parse(htmlDecode(accordions));
  const [currentSelected, setCurrentSelected] = React.useState(null);

  const variants = {
    initial: {
      height: 0,
      transition: {
        duration: 0.1,
      },
    },
    animate: {
      height: 'auto',
      transition: {
        duration: 0.1,
      },
    },
  };
  return (
    <div className="mb-12">
      {accordionBlocks && (
        <div>
          {accordionBlocks.map((accordion, key) => (
            <div key={key}>
              <div className="cursor-pointer p-4 border border-gray-light mb-4 flex justify-between items-center flex-col md:flex-row">
                <h3
                  className="text-secondary mb-4 md:mb-0"
                  dangerouslySetInnerHTML={{ __html: accordion.title }}
                />
                {accordion.iframe_url && (
                  <a
                    href={accordion.iframe_url}
                    className="btn"
                    target="_blank"
                  >
                    View Estimator
                  </a>
                )}
              </div>

              <AnimatePresence>
                {currentSelected === key && (
                  <motion.div
                    variants={variants}
                    initial="initial"
                    animate="animate"
                    exit="initial"
                    className="mt-4"
                  >
                    <iframe
                      src={accordion.iframe_url}
                      className="border-none"
                      height={`1000px`}
                      width={`100%`}
                    />
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
